module.exports = __webpack_public_path__ + "static/calefaccion-e805069b338331be017c360c6da60db9.jpg";